<template>
  <span
    class="tw-font-sans tw-text-sm"
    :class="linkClasses"
    data-walkthrough-id="edit-remark-modal-add-attachment"
  >
    <span class="tw-inline-block tw-mr-0.5 fa fa-paperclip"></span>
    {{ I18n.t('adjustment.modal.add_attachment') }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import useI18n from '@app/shared/vue/composables/use-I18n'

interface Props {
  disabled?: boolean
}

const props = defineProps<Props>()

const I18n = useI18n()

const linkClasses = computed(() => {
  return {
    'sf-a': !props.disabled,
    'sf-pointer': !props.disabled,
    'tw-text-sf-primary-dark': !props.disabled,
    'tw-text-sf-gray-lighter': props.disabled,
    'hover:tw-text-sf-gray-lighter': props.disabled,
    'tw-cursor-not-allowed': props.disabled,
  }
})
</script>
